<template>
    <div class="page-layout blank contacts-manage mb-10 mt-5">
        <div class="general-section pt-2 pb-6 px-0 px-sm-4 mt-4">
            <div class="mt-5 mb-5">
                <!-- <h6 class="text-blue-new fw-600 text-center pb-1 pt-1 fs-20">CREATE NEW TICKET</h6>
                <div class="text-center mt-5 mb-5">
                    <button class="btn activeDetail">Software Bug Details</button>
                </div> -->
                <div class="general-section pb-6 mt-3 boxShadows px-0 px-lg-4">
                    <div class="row justify-content-between boxHeaders">
                        <div>Product Bug Details</div>
                    </div>
                    <div class="row m-0">
                        <div class="col-lg-4 col-md-4 col-sm-12 mt-8">
                            <div>
                                <span class="whiteSpace fs-14 fw-600 ml-2">Product<span class="text-danger pl-1">*</span></span>
                                <div class="">
                                    <div class="d-flex align-items-center mt-4">
                                        <multiselect
                                            label="name"
                                            v-validate="'required'"
                                            class="diginew-multiselect"
                                            name="product"
                                            data-vv-as="Product"
                                            v-model="product"
                                            :options="allProducts"
                                            :searchable="true"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Select Product"
                                            :loading="product_loading" @search-change="getAllProduct"
                                        >
                                            <template slot="afterList">
                                                <div v-observe-visibility="reachedEndOfProduct" />
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                        <div class="ml-2">
                                            <!-- <el-tooltip class="item pull-right" effect="dark" content="Dynamic template creation coming soon !!" placement="top"> -->
                                                <i class="icon icon-plus-circle text-success pointer" @click="goToScmProduct"></i>
                                            <!-- </el-tooltip> -->
                                        </div>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('product')">{{ errors.first('product') }}</span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-lg-4 col-md-4 col-sm-12 mt-8">
                            <div>
                                <span class="whiteSpace fs-14 fw-600 ml-2">Creation Type<span class="text-danger pl-1">*</span></span>
                                <div class="">
                                    <multiselect
                                        v-validate="'required'"
                                        class="diginew-multiselect mt-4"
                                        name="creation_type"
                                        v-model="creation_types"
                                        :options="creation_type_options"
                                        :searchable="true"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        placeholder="Select Creation Type"
                                    >
                                    </multiselect>
                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('creation_type')">{{ errors.first("creation_type") }}</span>
                                </div>
                            </div>
                        </div> -->
                        <div class="col-lg-4 col-md-4 col-sm-12 mt-8">
                            <div>
                                <span class="whiteSpace fs-14 fw-600 ml-2">Issue Type</span>
                                <div class="">
                                    <multiselect
                                        class="diginew-multiselect mt-4"
                                        name="type"
                                        v-model="type"
                                        :options="type_options"
                                        :searchable="true"
                                        :hide-selected="true"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        placeholder="Select Issue Type"
                                    >
                                    </multiselect>
                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('type')">{{ errors.first("type") }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 mt-8" v-if="show_priority">
                            <div>
                                <span class="whiteSpace fs-14 fw-600 ml-2">Priority<span class="text-danger pl-1">*</span></span>
                                <div class="">
                                    <multiselect
                                        v-validate="'required'"
                                        class="diginew-multiselect mt-4"
                                        name="priority"
                                        v-model="priority"
                                        :options="priority_options"
                                        :searchable="true"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        placeholder="Select Priority"
                                    >
                                    </multiselect>
                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('priority')">{{ errors.first("priority") }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 mt-8">
                            <!-- <div class="w-100">
                                <label class="inputLabel fs-14 fw-600 text-black">Tags <span class="text-danger pl-1">*</span></label>
                                <input v-validate="'required'" name="tag" class="inputFieldNew" type="text" v-model="tags" placeholder="Add Tags" />
                                <span class="inputBorder"></span>
                                <span class="invalid-feedback-form text-danger mt-0 text-left d-block" v-show="errors.has('tag')" style="display: inline !important">{{ errors.first("tag") }}</span>
                            </div> -->
                            <label class="inputLabel fs-14 fw-600 text-black">Tags</label>
                            <vue-tags-input v-model="tag" class="mt-2" name="tags" id='tags' :tags="tags" @tags-changed="newTags => tags = newTags" />
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 mt-8">
                            <div>
                                <span class="whiteSpace fs-14 fw-600 ml-2 text-capitalize">Is It Functional Bug ?<span class="text-danger pl-1">*</span></span>
                                <!-- <div class="d-flex align-items-center mt-5 ml-2">
                                    <div class="d-flex align-items-center">
                                        <input type="radio" class="pointer" v-model="is_functional" value="true">
                                        <span class="pl-5 pointer">Yes</span>
                                    </div>
                                    <div class="d-flex align-items-center ml-7">
                                        <input type="radio" class="pointer" v-model="is_functional" value="false">
                                        <span class="pl-5 pointer">No</span>
                                    </div>
                                </div> -->
                                <!-- <el-radio-group v-model="is_functional" class="radiogroupcol"> -->
                                <div class="d-flex align-items-center mt-7 ml-2">
                                    <el-radio-group v-model="is_functional">
                                        <el-radio :label="true">
                                            Yes
                                        </el-radio>
                                        <el-radio :label="false">
                                            No
                                        </el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-10 mb-3">
                        <a class="btn btn-danger btn-smm-new text-white mr-0" style="text-transform: uppercase !important;font-size: 12px !important;" @click="cancel()">Cancel</a>
                        <button type="button" v-if="check_ticket_template_type == 'Product' || check_ticket_template_type == 'Equipment'" class="btn btn-secondary btn-smm-new ml-3" style="box-shadow: none;" @click="saveAsDraft()">
                            Save as Draft
                        </button>
                        <button type="button" class="btn btn-success text-white btn-smm-new ml-3" style="box-shadow: none;" @click="validateNext()">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <preview-ticket :source="'Product Bug Template'" v-if="showPreview" :is_saving="is_saving" @cancelTicketDetails="cancelTicketDetails" :check_ticket_template_type="check_ticket_template_type" @saveTicketDetails="saveTicketDetails" :view_json="view_json" :storedDetails="storedDetails" modal_name="ticket-preview"></preview-ticket>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="please_wait">Please wait</sweet-modal>
        <ticket-success v-if="ticket_success" @saveTicketDetailsAsDraft="saveAsDraft" :api_response ="api_response" modal_name="success-ticket"></ticket-success>
    </div>
</template>

<script>
const PreviewTicket = () => import("./PreviewTicket");
const TicketSuccess = () => import("./TicketSuccess")
import VueTagsInput from "@johmun/vue-tags-input";
import { SweetModal } from 'sweet-modal-vue';
import scm from '../mixins/scm.js';
import ticket from '../mixins/ticket.js';
import setting from '../mixins/setting.js';
import global from '../global.js';
export default {
    mixins:[scm,ticket, setting],
    props: ['check_ticket_template_type'],
    components:{
        PreviewTicket,
        SweetModal,
        TicketSuccess,
        VueTagsInput
    },
    data(){
        return{
            success_msg:'',
            warning_msg:'',
            product_loading:false,
            product_scrollable:false,
            product_count:0,
            allProducts:[],
            product:'',
            temp_allProducts:[],
            product_visible:false,
            creation_type_options:['Email', 'Others', 'Phone','Social Media'],
            creation_types:'',
            type_options:['Bug', 'Crashes', 'Help', 'Incident', 'New Feature','Request'],
            type:'Incident',
            priority_options:['High','Low', 'Medium'],
            priority:'Medium',
            tag: '',
            tags: [],
            is_functional:true,
            showPreview:false,
            is_validated:false,
            show_priority: false,
            is_saving: false,
            ticket_success: false
        }
    },
    methods:{
        cancel(){
            this.$emit('hideSBR', 'Product Bug Template');
        },
        goToScmProduct() {
            window.open(`${global.SCM_URL}/inventory/products/create`, "_blank")
        },
        async getAllProduct(search_key){
            try {
                this.product_loading = true
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key,
                    // customer_id:this.crm_customer_id
                }
                let res = await this.getSCMProducts(params)
                this.allProducts = res.response.products
                this.product_count = this.temp_allProducts.length
                this.product_loading = false
                this.product_scrollable = false
            } catch (reason) {
                
            }
        },
        async reachedEndOfProduct(reached){
            this.product_visible = reached
            if (reached) {
                if (this.product_scrollable == false) {
                    this.product_loading = true
                    let params ={
                        skip:this.product_count,
                        limit:10,
                        search_key:this.search_key,
                        // customer_id:this.crm_customer_id
                    }
                    let response = await this.getSCMProducts(params)
                    this.temp_allProducts = response.response.products.length;
                    if (response.response.skip == this.product_count) {
                        if (this.temp_allProducts > 0) {
                            let tempFiles = response.response.products;
                            tempFiles.forEach(el => {
                                this.allProducts.push(el);
                            });
                            this.product_count += response.response.products.length;
                            this.product_loading = false
                        } else {
                            this.product_scrollable = true
                            this.product_loading = false
                        }
                    }
                    this.product_loading = false
                }
            }
        },
        validateNext(){
            this.$validator.validateAll().then(result => {
                if(result) {
                    this.showPreview = true
                    setTimeout(() => {
                        this.$modal.show('ticket-preview');
                    }, 500);
                }
            })
        },
        cancelTicketDetails(){
            this.showPreview = false
        },
        async confirmSave(params){
            this.is_saving = true;
            this.$refs.please_wait.open();
            try {
                let param = params
                let res = await this.addTicket(param)
                this.api_response = res.response
                this.is_saving = false;
                setTimeout(() => {
                    this.$refs.please_wait.close();
                }, 500);
                this.ticket_success = true;
                setTimeout(() => {
                    this.$modal.show('success-ticket');
                }, 1000);
                setTimeout(() => {
                    localStorage.removeItem("productDetails");
                    localStorage.removeItem("ticketDetails");
                }, 1000);
            } catch (reason) {
                this.is_saving = false;
                setTimeout(() => {
                    this.$refs.please_wait.close();
                }, 1000);
                this.warning_msg = reason
                this.$swal({
                    imageUrl:'https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/dog.svg',
                    text: this.warning_msg,
                    showConfirmButton:false
                })
            }
        },
        saveAsDraft(){
            this.$validator.validateAll().then(result => {
                if (result == true){
                    this.confirmSaveDraft()
                }
            })
        },
        async confirmSaveDraft(){
            try {
                let res = await this.draftSave(this.save_as_draft)
                this.success_msg = res.response.success_message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    localStorage.removeItem("productDetails");
                    localStorage.removeItem("ticketDetails");
                }, 1000);
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    let id = res.response.draft_ticket_id
                    this.$router.push({
                        path: '/draftview/'+id
                    })
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$swal({
                    imageUrl:'https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/dog.svg',
                    text: this.warning_msg,
                    showConfirmButton:false
                })
                // this.$refs.warning_modal.open();
                // setTimeout(() => {
                //     this.$refs.warning_modal.close();
                // }, 3000);
            }
        },
        saveTicketDetails(){
            this.showPreview = false
            this.create_json.template_data.tags.forEach((el,index)=>{
                this.create_json.template_data.tags[index] = el.text;
                delete el.text
                delete el.tiClasses
            })
            this.confirmSave(this.create_json)
        },
        async getIsShowPriority() {
            let param = {
                settings_type: ['display_ticket_priorities']
            }
            let data = await this.getAllJobTypes(param);
            this.show_priority = data.response.display_ticket_priorities.display_ticket_priorities;
        },
    },
    mounted(){
        this.getIsShowPriority();
        this.storedDetails = JSON.parse(localStorage.getItem("ticketDetails"))
        // this.customer_address = this.storedDetails.customer_address
        this.attachments = this.storedDetails.attachments
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        create_json(){
            return{
                assignment_details:{
                    id:this.storedDetails.assignedCustomer.id,
                    is_assigned: this.storedDetails.assignedTo == 'unassigned' ? false : true,
                    to:this.storedDetails.assignedTo
                },
                creation_details:{
                    for:this.storedDetails.behalf,
                    id:this.storedDetails.authorized_person_id
                },
                is_validated: true,
                department:this.storedDetails.department._id,
                description:this.storedDetails.description,
                text:this.storedDetails.description.replace(/(<([^>]+)>)/ig, ""),
                is_parent_ticket:this.storedDetails.is_parent_ticket,
                // parent_ticket_id:this.storedDetails.parent_ticket_id,
                subject:this.storedDetails.subject,
                attach_files:this.attachments,
                template_data:{
                    priority:this.priority,
                    products:this.product._id,
                    creation_type:this.creation_types == 'Social Media' ? 'social_media' : this.creation_types.toLowerCase(),
                    is_functional:this.is_functional,
                    type:this.type == 'New Feature' ? 'new_feature' : this.type.toLowerCase(),
                    tags:this.tags
                },
                ticket_template:this.storedDetails.ticket_template._id
            }
        },
        save_as_draft(){
            return{
                assignment_details:{
                    id:this.storedDetails.assignedCustomer.id,
                    is_assigned: this.storedDetails.assignedTo == 'unassigned' ? false : true,
                    to:this.storedDetails.assignedTo
                },
                creation_details:{
                    for:this.storedDetails.behalf,
                    id:this.storedDetails.authorized_person_id
                },
                department:this.storedDetails.department._id,
                description:this.storedDetails.description,
                text:this.storedDetails.description.replace(/(<([^>]+)>)/ig, ""),
                is_parent_ticket:this.storedDetails.is_parent_ticket,
                // parent_ticket_id:this.storedDetails.parent_ticket_id,
                subject:this.storedDetails.subject,
                attach_files:this.attachments,
                template_data:{
                    priority:this.priority,
                    products:this.product._id,
                    creation_type:this.creation_types == 'Social Media' ? 'social_media' : this.creation_types.toLowerCase(),
                    is_functional:this.is_functional,
                    type:this.type == 'New Feature' ? 'new_feature' : this.type.toLowerCase(),
                    tags:this.tags
                },
                ticket_template:this.storedDetails.ticket_template._id,
                is_validated:this.is_validated
            }
        },
        view_json(){
            return{
                attach_files:this.attachments,
                priority:this.priority,
                products:this.product,
                creation_type:this.creation_types,
                tags:this.tags,
                type:this.type,
                is_functional:this.is_functional
            }
        },
    },
    created(){
        const dict = {
            custom: {
                product:{
                    required:() => "Product is Required",
                },
                type:{
                    required:() => "Type is Required",
                },
                priority:{
                    required:() => "Priority is Required",
                },
                creation_type:{
                    required:() => "Creation Type is Required",
                },
                tag:{
                    required:() => "Tags is Required",
                }
            }
        }
        this.$validator.localize("en", dict); 
    },
}
</script>

<style scoped>

.activeDetail{
    background-color: #29c2e0 !important;
    color: #fff !important;
    width: 200px !important;
    border-radius: 5px !important;
    height: 40px !important;
    font-weight: 500 !important;
    text-transform: none;
    font-size: 16px !important;
}
.boxHeaders{
    background: #005dae;
    color: #fff;
    padding: 10px 25px;
    font-weight: 500;
    font-size: 14px;
    border-top-left-radius:7px;
    border-top-right-radius:7px;
}
.boxShadows{
    box-shadow: 0px 0.5px 7px 2px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    border-radius: 8px;
}
.btn-smm-new{    
    height: 30px !important;
    padding: 0 18px !important;
    border-radius: 6px !important;
    font-size: 12px !important;
    line-height: 30px !important;
    text-transform: none;
    font-weight: 600 !important;
}
</style>